import React, { useMemo } from 'react';
import { inspectionData } from '~/types';
import useTranslation from '~/app/hooks/useTranslation';
import InspectionGraph from '../InspectionGraph';
import ReportCard from '../../ReportCard';
import ReportCardRightSideInfo from '../../common/ReportCardRightSideInfo';
import { useStoreState } from '~/store';

export interface InspectionReportCardProps {
    inspectionData: inspectionData
}

export type InspectionReportCardComponent = React.FC<InspectionReportCardProps>;

const InspectionReportCard: InspectionReportCardComponent = ({ inspectionData }) => {
    const { t } = useTranslation("machine.dashboard");
    const periodicCheckReportIntervalCount = useStoreState(state => state.machines.periodicCheckReportIntervalCount);
    const periodicCheckReportIntervalType = useStoreState(state => state.machines.periodicCheckReportIntervalType);
    const periodicCheckReportAverageIntervalCount1 = useStoreState(state => state.machines.periodicCheckReportAverageIntervalCount1);
    const periodicCheckReportAverageIntervalType1 = useStoreState(state => state.machines.periodicCheckReportAverageIntervalType1);
    const periodicCheckReportAverageIntervalCount2 = useStoreState(state => state.machines.periodicCheckReportAverageIntervalCount2);
    const periodicCheckReportAverageIntervalType2 = useStoreState(state => state.machines.periodicCheckReportAverageIntervalType2);

    const firstSectionData = useMemo(() => {
        return {
            title: t('averageInterval', {interval: periodicCheckReportAverageIntervalCount1, type: t(`${periodicCheckReportAverageIntervalType1}${periodicCheckReportAverageIntervalCount1 > 1 ? 's' : ''}`)}),
            data:`${inspectionData.last6MonthsPeriodicChecks}%`,
            performanceData: inspectionData.last6MonthsPerformanceCompareToAverage
        }
    }, [inspectionData.last6MonthsPerformanceCompareToAverage, inspectionData.last6MonthsPeriodicChecks, periodicCheckReportAverageIntervalCount1, periodicCheckReportAverageIntervalType1, t]);

    const secondSectionData = useMemo(() => {
        return {
            title: t('averageInterval', {interval: periodicCheckReportAverageIntervalCount2, type: t(`${periodicCheckReportAverageIntervalType2}${periodicCheckReportAverageIntervalCount2 > 1 ? 's' : ''}`)}),
            data: `${inspectionData.last12MonthsPeriodicChecks}%`,
            performanceData: inspectionData.last12MonthsPerformanceCompareToAverage
        }
    }, [inspectionData.last12MonthsPerformanceCompareToAverage, inspectionData.last12MonthsPeriodicChecks, periodicCheckReportAverageIntervalCount2, periodicCheckReportAverageIntervalType2, t]);

    return (
        <ReportCard
            title={t(`inspectionRate.title`)}
            subtitle={t(`onTarget`, { targetPercentage: inspectionData.TargerPercentage })}
            dateOfLastAvailableData={inspectionData.previousWorkingDay}
            rightSideInfo={<ReportCardRightSideInfo
                firstSection={firstSectionData}
                secondSection={secondSectionData}
                reverseColors={true}
            />}
            mainGraphTitle={t('lastInterval', {interval: periodicCheckReportIntervalCount, type: t(`${periodicCheckReportIntervalType}${periodicCheckReportIntervalCount > 1 ? 's' : ''}`)})}
            mainGraph={<InspectionGraph inspectionData={inspectionData} />}
        />
    )
}

export default InspectionReportCard